// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"226":"fe5afbd9","331":"8f6604a5"}[chunkId] + ".js";
};